import styled from 'styled-components';

export const Surveys = styled.div`
  height: 100%;
  .survey-component {
    height: 100%;
  }
`